/**
 * @generated SignedSource<<6fe8dd5c0d1adc3e129fb35c82646480>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ResetbindcardtransactionPayload",
    "kind": "LinkedField",
    "name": "resetbindcardtransaction",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "integer",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResetBindCardTransactionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResetBindCardTransactionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "33bf593b32213ed453339821bcf903d8",
    "id": null,
    "metadata": {},
    "name": "ResetBindCardTransactionMutation",
    "operationKind": "mutation",
    "text": "mutation ResetBindCardTransactionMutation(\n  $input: ResetbindcardtransactionInput!\n) {\n  resetbindcardtransaction(input: $input) {\n    integer\n  }\n}\n"
  }
};
})();

node.hash = "03523aa2a3382603791bf344a7ff6f4a";

module.exports = node;
